import { apiClient, handleApiRequest } from './client'

export type DocDue = 'never' | 'immediate' | 'after_days'

export interface AbsenceTypeBase {
  id: string
  key: string
  label: string
  sort_order: number
}

export interface AbsenceTypeFull extends AbsenceTypeBase {
  is_active: boolean
  gate_approval_required: boolean
  doc_due: DocDue
  doc_due_days: number | null
  is_protected: boolean
}

export interface AbsenceTypeCreatePayload {
  label: string
  gate_approval_required?: boolean
  doc_due?: DocDue
  doc_due_days?: number | null
}

export interface AbsenceTypeUpdatePayload {
  label?: string
  is_active?: boolean
  gate_approval_required?: boolean
  doc_due?: DocDue
  doc_due_days?: number | null
}

export const absenceTypesApi = {
  list: () =>
    handleApiRequest<{ absence_types: AbsenceTypeBase[] | AbsenceTypeFull[] }>(
      apiClient.get('/api/v1/absence-types')
    ),
  create: (payload: AbsenceTypeCreatePayload) =>
    handleApiRequest<AbsenceTypeFull>(
      apiClient.post('/api/v1/absence-types', payload)
    ),
  update: (id: string, payload: AbsenceTypeUpdatePayload) =>
    handleApiRequest<AbsenceTypeFull>(
      apiClient.put(`/api/v1/absence-types/${id}`, payload)
    ),
  remove: (id: string) =>
    handleApiRequest<{ ok: boolean; affected_requests: number }>(
      apiClient.delete(`/api/v1/absence-types/${id}`)
    ),
  reorder: (orderedIds: string[]) =>
    handleApiRequest<{ ok: boolean }>(
      apiClient.post('/api/v1/absence-types/reorder', { ordered_ids: orderedIds })
    ),
}
